import styled from "styled-components";

export const ArenaHeaderButtonBackgroundDefaultBox = styled.div`
    width: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;
    padding-bottom: 100%;
 `;